import { ResultList as HeadlessResultList } from '@coveo/headless';
import { useEffect, useState, FunctionComponent } from 'react';
// import {Quickview} from '../quickview/quickview.fn';
import { ResultLink } from './result-link';
import React from 'react';

interface ResultListProps {
	controller: HeadlessResultList;
	filterBy?: {
		property: string;
		value: any;
	};
	resultsView?: string;
}

export const ResultList: FunctionComponent< ResultListProps > = ( props ) => {
	const { controller, filterBy, resultsView } = props;
	const [
		state,
		setState,
	] = useState( controller.state );

	useEffect( () => controller.subscribe( () => setState( controller.state ) ), [] );

	const filteredResults = filterBy ? state.results.filter( ( result ) => result.raw[ filterBy.property ] === filterBy.value ) : state.results;

	if ( ! filteredResults.length ) {
		return null;
	}

	return (
		<>
			{ filteredResults.map( ( result ) => {
				// Convert the number to a Date object
				const date = new Date( result.raw[ 'date' ] as number );

				// Format the date using toLocaleDateString
				const formattedDate = date.toLocaleDateString( 'en-US', {
					year: 'numeric',
					month: 'long',
					day: 'numeric',
				} );

				return (
					<div key={ result.uniqueId } className="dyn-card">
						<div className="dyn-card__wrap">
							{ 'card' === resultsView && (
								<div className="dyn-card__media">
									<figure className="dyn-card__image">
										<ResultLink result={ result } className="dyn-card__image-link">
											{ !! result.raw[ 'imagepreview' ] ? (
												<img
													src={ result.raw[ 'imagepreview' ] as string }
													alt=""
													style={ { objectPosition: '50% 50%' } }
													className="attachment-medium size-medium"
													decoding="async"
													width={ 300 }
													height={ 300 }
												/>
											) : (
												<div className="dyn-card__image-placeholder">
													<span className="a11y">Placeholder</span>
												</div>
											) }
										</ResultLink>
									</figure>
								</div>
							) }

							<div className="dyn-card__content">
								<h2 className="dyn-card__title has-h5-variant">
									<ResultLink
										result={ result }
										externalIcon
									>
										{ result.title }
									</ResultLink>
								</h2>
								<div className="dyn-card__link">
									<ResultLink
										result={ result }
									>
										{ result.clickUri }
									</ResultLink>
								</div>
								<div className="dyn-card__excerpt">{ result.excerpt }</div>
							</div>
						</div>
					</div>
				);
			} ) }
		</>
	);
};

// usage

/**
 * ```tsx
 * const controller = buildResultList(engine);
 *
 * <ResultList controller={controller} />;
 * ```
 */
